import React from 'react';
import { debounce } from 'throttle-debounce';

import { CONFIG } from '@constants/config';

export function useDebouncedValue(handler = () => {}, options) {

  const {
    ms = CONFIG.DURATIONS.USER_ACTIONS_DEBOUNCE,
    initialValue = 0
  } = options;

  const [previousValue, setPreviousValue] = React.useState(initialValue);
  const [value, setValue] = React.useState(initialValue);

  // Handlers

  // --- Debounced Handler

  const debounced = React.useCallback(debounce(ms, (prevValue, newValue) => {
    handler(prevValue, newValue);
  }), [handler]);

  // --- Increase

  const increase = React.useCallback(() => {
    setValue((prev) => prev + 1);
  }, []);

  // --- Decrease

  const decrease = React.useCallback(() => {
    setValue((prev) => prev - 1);
  }, []);

  // --- Reset

  const reset = React.useCallback(() => {
    setValue(previousValue);
  }, [previousValue]);

  // --- Update

  const update = React.useCallback((newValue) => {
    setValue(newValue);
  }, []);

  // Effects

  React.useEffect(() => {
    setPreviousValue(initialValue);
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    debounced(previousValue, value);
  }, [previousValue, value]);

  return {
    value,
    reset,
    decrease,
    increase,
    update
  };
}
